<template>
  <div class="card container" style="height:90%;border: 0px solid #000000;padding: 12px;border-radius: 12px;margin: auto;background:#FFFFFF;">
    <!-- <ul class="progressbar">
          <li v-bind:class="{ active: this.active_step == 1 }">Choose Section</li>
          <li v-bind:class="{ active: this.active_step == 2 }">Choose File</li>
          <li v-bind:class="{ active: this.active_step == 3 }">Upload</li>
    </ul> -->

       <div class="form-group" style="width:100%;text-align:left;">
              <label for="section">Select Data Type:</label>
              <select name="section" style="width:200px;" v-model="upload_section">
                <option v-for="section in uploadSections" v-bind:key='section'>{{section}}</option>
              </select>
        </div>
      

    <div v-if="this.hasUpload" v-show="edit" style="margin-left: 0px;">
        <div class="form-group">
          <label for="filename">File:&nbsp;&nbsp;</label><span name="filename"><i class="fa fa-file"></i>&nbsp;&nbsp;{{filename}}</span>
                   <br/>
        </div>
      <label>Summary:&nbsp;&nbsp;</label>
      <div v-if="this.showWarning">
        <table>
          <tr>
            <td width="30px;">{{locations.length}}</td>
            <td colspan="3">Data Rows</td>
          </tr>
          <tr>
            <td >{{found_optional_headers.length}}</td>
            <td style="width: 25px;"><i class="fa fa-check"></i></td>
            <td>Optional Headers</td>
            <td><select style="width:150px;">
               <option v-for="item2 in found_optional_headers" v-bind:key='item2'>
              {{item2}}
              </option>
              </select>
            </td>
          </tr>
           <tr>
            <td>{{unknown_headers.length}}</td>
            <td><i class="fa fa-exclamation-triangle"></i></td>
            <td>Unknown Headers</td>          
            <td><select style="width:150px;">
              <option v-for="item3 in unknown_headers" v-bind:key="item3">{{item3}}</option>
              </select>
            </td>
          </tr>
          <tr style="color: #770000;" v-if="this.missing_required_headers.length > 0">
             <td>{{missing_required_headers.length}}</td>
            <td><i class="fa fa-exclamation"></i></td>
            <td>Missing Headers</td>          
            <td><select style="width:150px;">
              <option v-for="item4 in missing_required_headers" v-bind:key="item4">{{item4}}</option>
              </select>
            </td>
          </tr>
        </table>
      </div>
      </div>


    <div style="width:100%;text-align:center;background:#FFFFFF;margin-top: 20px;" v-show="!edit">
      <div class="stitched">
          <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
            <h3>Drop files to upload</h3>
          </div>
            <div class="location-upload"  >
              <div style="width:100%;text-align:center;background:#FFFFFF;">
                <img src="/static/img/baseline_cloud_upload_black_48dp.png" style="margin: auto;">
                <p>Drag and Drop</p>
                <p>or</p>
              </div>
            </div>
            <div class="text-center p-2">
              <file-upload
                extensions="csv,xls,xslx"
                name="locations"
                class="btn btn-primary"
                :drop="!edit"
                v-model="files"
                @input-file="inputFile"
                ref="upload">{{uploadButtonDescription}}
              </file-upload>
            </div>

        <!-- <label class="text-reader">
          <input type="file" @change="loadTextFromFile">
        </label> -->
        </div>


    </div>
    <div style="width:100%;text-align:right;background:#FFFFFF;margin-top: 40px;">
      <button class="btn btn-default" @click="cancel">Cancel</button>
      <button style="color: #103E5A;border-color: #103E5A;" v-if="!this.canSaveFile" class="btn btn-outline-primary disabled" >Upload</button>
      <button v-if="this.canSaveFile" class="btn btn-primary" @click="createNode">Upload</button>
      
    </div>

	</div>
</template>

<script>
import { db, storage } from '../../firebase'
import XLSX from 'xlsx'
import FileUpload from 'vue-upload-component'
import axios from 'axios'

export default {
  data: () => ({
    filename: 'default.csv',
    valid: false,
    locations: [],
    headers: [],
    missing_required_headers: [],
    found_optional_headers: [],
    unknown_headers: [],
    last_headers: [],
    file: null,
    files: [],
    edit: false,
    upload_section: 'localbusiness',
    active_step: 1
  }),
  props: {
    required_fields: {
      type: Object,
      default: function () { return { 'localbusiness': ['Store code', 'Business name', 'Address line 1', 'Locality', 'Administrative area', 'Country / Region', 'Postal code', 'Latitude', 'Longitude', 'Primary phone'], 'offer': ['Store code', 'Business name', 'Address line 1', 'Address line 2', 'Locality', 'Administrative area', 'Country / Region', 'Postal code', 'Latitude', 'Longitude', 'Primary phone', 'Sunday hours', 'Monday hours', 'Tuesday hours', 'Wednesday hours', 'Thursday hours', 'Friday hours', 'Saturday hours'] } }
    },
    optional_fields: {
      type: Object,
      default: function () { return { 'localbusiness': ['Address line 2', 'Address line 3', 'Address line 4', 'Address line 5', 'Sub-locality', 'Additional phones', 'Website', 'Primary category', 'Additional categories', 'Sunday hours', 'Monday hours', 'Tuesday hours', 'Wednesday hours', 'Thursday hours', 'Friday hours', 'Saturday hours', 'Special hours', 'From the business', 'Opening date', 'Profile photo', 'Logo photo', 'Cover photo', 'Other photos', 'Labels', 'AdWords location extensions phone', 'c:Custom Field'], 'offer': ['Address line 3', 'Address line 4', 'Address line 5', 'Sub-locality', 'Additional phones', 'Website', 'Primary category', 'Additional categories', 'Special hours', 'From the business', 'Opening date', 'Profile photo', 'Logo photo', 'Cover photo', 'Other photos', 'Preferred photo'] } }
    },
    uploadSections: {
      type: Array,
      default: function () { return ['localbusiness', 'offer'] }
    }
  },
  components: {
    FileUpload
  },
  computed: {
    hasUpload: function () {
      return this.filename != null
    },
    canSaveFile: function () {
      return this.filename != null && this.missing_required_headers.length === 0 && this.headers.length > 0 && this.upload_section != null && this.upload_section.length > 0
    },
    showWarning: function () {
      return this.filename != null && (this.optional_fields[this.upload_section].length > 0 || this.unknown_headers.length > 0)
    },
    uploadButtonDescription: function () {
      return 'Select Your ' + this.upload_section + ' File (CSV or Excel)'
    }
  },
  created: function () {
    // this.upload_sections = this.$store.state.sections
    if (this.uploadSections.length > 0) {
      this.upload_section = this.uploadSections[0]
    }
  },
  methods: {
    cancel: function () {
      this.$emit('exit', true)
      this.resetForm()
    },
    resetForm: function () {
      this.filename = 'default.csv'
      this.valid = false
      this.locations = []
      this.headers = []
      this.missing_required_headers = []
      this.found_optional_headers = []
      this.unknown_headers = []
      this.file = null
      this.$refs.upload.clear()
      this.files = []
      this.edit = false
      this.last_headers = []
      if (this.uploadSections.length > 0) {
        this.upload_section = this.uploadSections[0]
      }
    },
    gotoUpload: function () {
      this.active_step = 3
    },
    choseSection: function () {
      this.active_step = 2
    },
    createNode: function () {
      // var rootRef = this.$firebaseRefs.fbLocalBusiness.ref
      // console.log(rootRef)
      var self = this
      var newUpload = {
        user: window.firebase.auth().currentUser.email,
        filename: '',
        original_filename: this.filename,
        status: 'uploading',
        updatedAt: (new Date()).toString(),
        size: 234,
        report: '',
        section: this.upload_section,
        location: '',
        download_url: ''
      }
      var newkey = this.$firebaseRefs.fbLocalBusiness.push().key
      var extension = this.filename.split('.').pop()
      newUpload.filename = newkey + '.' + extension
      var newFilename = newkey + '.' + extension
      var storageLocationSection = this.upload_section

      let storageRef = storage.ref().child('upload_tool').child(storageLocationSection).child(this.$route.params.organization).child(newFilename)
      storageRef.put(this.file)
          .then(snap => {
            const downloadURL = snap.downloadURL
            newUpload.status = 'uploaded'
            newUpload.updatedAt = (new Date()).toString()
            newUpload.filename = newFilename
            self.$firebaseRefs.fbLocalBusiness.child(newkey).set(newUpload)
            self.$store.commit('appendItems', {firebaseNode: 'Uploads', items: [newUpload]})
            self.$store.commit('addItemToSearch', {item: newUpload, firebaseNode: 'Uploads'})
            newUpload.download_url = downloadURL
            newUpload.location = `/upload_tool/${storageLocationSection}/${self.$route.params.organization}/${newFilename}`
            self.$firebaseRefs.fbLocalBusiness.child(newkey).set(newUpload)
            const url = 'https://eztt6ned80.execute-api.us-east-1.amazonaws.com/staging/raptorStagingDashboardService'
            axios.post(url, {
              'accessToken': self.$store.getters.accessToken,
              'clientSlug': this.$store.getters.organization.id,
              'fileID': newkey
            }, {
              headers: {
                'Content-Type': 'application/json'
              }
            })
            .then(function (response) {
              console.log(response)
              self.$emit('exit', true)
              self.resetForm()
            })
            .catch(function (error) {
              console.log(error)
              self.$emit('exit', true)
              self.resetForm()
            })
          })
      console.log(storageRef)
    },
    loadTextFromFile () {
      var self = this
      if (this.file == null) return
      var fileReader = new FileReader()
      var filename = this.file.name
      var isExcel = filename.toLowerCase().indexOf('.xls') >= 0 || filename.toLowerCase().indexOf('.xlsx') >= 0
      if (isExcel) {
        fileReader.readAsArrayBuffer(this.file)
      } else {
        fileReader.readAsText(this.file)
      }
      fileReader.onload = function (e) {
        var result = { status: 0, headers: [], locations: [] }
        if (filename.toLowerCase().indexOf('.xls') >= 0 || filename.toLowerCase().indexOf('.xlsx') >= 0) {
          result = self.onReadExcelFile(e, filename)
        } else {
          result = self.onReadCsvFile(e, filename)
        }
        self.filename = filename
        self.headers = result.headers
        self.locations = result.locations
        self.last_headers = result.headers
        var report = self.checkRequiredHeaders(result.headers)
        self.missing_required_headers = report.missing_required
        self.found_optional_headers = report.contains_optional
        self.unknown_headers = report.unknown
      }
    },
    onReadExcelFile (e, fname) {
      var binary = ''
      var bytes = new Uint8Array(e.target.result)
      var length = bytes.byteLength
      for (var i = 0; i < length; i++) {
        binary += String.fromCharCode(bytes[i])
      }
      var file = XLSX.read(binary, {type: 'binary', cellDates: true, cellStyles: true})
      this.valid = this.validateFields(file)
      console.log(file.Sheets[Object.keys(file.Sheets)[0]])
      const sheetJson = XLSX.utils.sheet_to_json(file.Sheets[Object.keys(file.Sheets)[0]], {header: 1})
      console.log(sheetJson)
      const header = sheetJson.shift()
      console.log('here')
      return {
        status: 1,
        headers: header,
        locations: sheetJson
      }
    },
    onReadCsvFile (e) {
      var csv = e.target.result
      var lines = csv.split('\n')
      var result = []
      var headers = lines[0].split(',')
      for (var i = 1; i < lines.length; i++) {
        var obj = []
        var currentline = lines[i].split(',')
        for (var j = 0; j < headers.length; j++) {
          obj.push(currentline[j])
        }
        result.push(obj)
      }
      return {
        status: 1,
        headers: headers,
        locations: result
      }
    },
    validateFields (file) {
      return this.checkSheetCount(file)
    },
    checkSheetCount (file) {
      return file.SheetNames.length === 1
    },
    checkRequiredHeaders (headers) {
      let missingRequiredHeaders = []
      let foundOptionalHeaders = []
      let unknownHeaders = []
      var headerCpy = headers.slice(0)
      for (var field in this.required_fields[this.upload_section]) {
        const idx = headerCpy.indexOf(this.required_fields[this.upload_section][field])
        if (idx !== -1) {
          const header = headerCpy.splice(idx, 1)
          console.log(header)
        } else {
          missingRequiredHeaders.push(this.required_fields[this.upload_section][field])
        }
      }

      for (var field2 in headerCpy) {
        const idx = this.optional_fields[this.upload_section].indexOf(headerCpy[field2])
        if (idx !== -1) {
//          const header = headerCpy.splice(idx, 1)
          foundOptionalHeaders.push(headerCpy[field2])
        } else if (headerCpy[field2].startsWith('c:')) {
          foundOptionalHeaders.push(headerCpy[field2])
        } else {
          unknownHeaders.push(headerCpy[field2])
        }
      }
      // Any other field should start with "c:".
      return {
        missing_required: missingRequiredHeaders,
        contains_optional: foundOptionalHeaders,
        unknown: unknownHeaders
      }
    },
    inputFile (newFile, oldFile, prevent) {
      var self = this
      if (newFile && !oldFile) {
        this.$nextTick(function () {
          this.edit = true
          self.file = newFile.file
        })
      }
      if (!newFile && oldFile) {
        this.edit = false
      }
    }
  },
  watch: {
    edit (value) {
      if (value) {
        this.loadTextFromFile()
      }
    },
    upload_section: function (newSection, oldSection) {
      var report = this.checkRequiredHeaders(this.last_headers)
      this.missing_required_headers = report.missing_required
      this.found_optional_headers = report.contains_optional
      this.unknown_headers = report.unknown
    }
  },
  firebase: function () {
    return {
      fbLocalBusiness: {
        source: db.ref('/Uploads/' + this.$route.params.organization),
        asObject: true,
        readyCallback: function (data) {
          // if (this.$route.params.entityId) {
          //   this.initData(this.fbLocalBusiness)
          // }
        }
      }
    }
  }
}
</script>
<style type="text/css">
.stitched {
    width: 100%;
   padding: 10px;
   margin: 10px;
   border: 2px dashed #DFDFDF;
   border-radius: 10px;
}
.container {
  width: 100%;
}

.progressbar {
  counter-reset: step;
}
.progressbar li {
  list-style: none;
  display: inline-block;
  width: 31.33%;
  position: relative;
  text-align: center;
  cursor: pointer;
}
.progressbar li:before {
  content: counter(step);
  counter-increment: step;
  width: 30px;
  height: 30px;
  line-height : 30px;
  border: 1px solid #ddd;
  border-radius: 100%;
  display: block;
  text-align: center;
  margin: 0 auto 10px auto;
  background-color: #fff;
}
.progressbar li:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  background-color: #ddd;
  top: 15px;
  left: -50%;
  z-index : -1;
}
.progressbar li:first-child:after {
  content: none;
}
.progressbar li.active {
  color: green;
}
.progressbar li.active:before {
  border-color: green;
} 
.progressbar li.active + li:after {
  background-color: green;
}
</style>



// WEBPACK FOOTER //
// LocationUpload.vue?c5bdac9c